import { render, staticRenderFns } from "./RequestVamNew.vue?vue&type=template&id=c3fd06fc&scoped=true&"
import script from "./RequestVamNew.vue?vue&type=script&lang=js&"
export * from "./RequestVamNew.vue?vue&type=script&lang=js&"
import style0 from "./RequestVamNew.vue?vue&type=style&index=0&id=c3fd06fc&scoped=true&lang=css&"
import style1 from "./RequestVamNew.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fd06fc",
  null
  
)

export default component.exports